import React from 'react';

const LinkExpiredView = ({
  title = 'Link Expired',
  message = 'This interview session has already been completed and securely closed.',
  helper = 'If you believe this is an error, please contact your HR representative.',
}) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background:
          'radial-gradient(circle at 20% 10%, #ffe6e0 0%, transparent 35%), radial-gradient(circle at 80% 90%, #dbeafe 0%, transparent 32%), linear-gradient(130deg, #0f172a 0%, #1e293b 45%, #0b1324 100%)',
        fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '640px',
          background: 'var(--bg-card-glass)',
          borderRadius: '20px',
          boxShadow: '0 24px 60px rgba(2, 6, 23, 0.45)',
          padding: '36px 30px',
          textAlign: 'center',
          border: '1px solid var(--border-color)',
          backdropFilter: 'blur(12px)',
        }}
      >
        <div
          style={{
            width: '88px',
            height: '88px',
            margin: '0 auto 18px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
            border: '1px solid #fca5a5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '40px',
          }}
        >
          ⏳
        </div>

        <div
          style={{
            letterSpacing: '0.08em',
            color: 'var(--text-muted)',
            fontSize: '12px',
            fontWeight: 700,
            marginBottom: '10px',
          }}
        >
          INTERVIEW SESSION CLOSED
        </div>

        <h2
          style={{
            margin: '0 0 12px 0',
            color: '#b91c1c',
            fontSize: '30px',
            lineHeight: 1.1,
          }}
        >
          {title}
        </h2>

        <p
          style={{
            margin: 0,
            color: 'var(--text-secondary)',
            fontSize: '16px',
            lineHeight: 1.65,
          }}
        >
          {message}
        </p>

        <div
          style={{
            marginTop: '24px',
            borderRadius: '12px',
            border: '1px solid #fecaca',
            background: '#fff1f2',
            color: '#9f1239',
            padding: '14px 16px',
            fontSize: '14px',
            lineHeight: 1.5,
          }}
        >
          {helper}
        </div>
      </div>
    </div>
  );
};

export default LinkExpiredView;
